import { useMutation } from "@tanstack/react-query";

import { mainApi } from "../../../../api";

export const useCheckAccountStatus = () => {
    return useMutation(() => mainApi.post("checkAccountStatus"));
};
